// extracted by mini-css-extract-plugin
module.exports = {"formulaContainer":"StaffReportTitle_formulaContainer__3MxL1"};